import { render } from "./AdminTestPurchaseResolved.vue?vue&type=template&id=224b3fab&scoped=true"
import script from "./AdminTestPurchaseResolved.vue?vue&type=script&lang=js"
export * from "./AdminTestPurchaseResolved.vue?vue&type=script&lang=js"

import "./AdminTestPurchaseResolved.vue?vue&type=style&index=0&id=224b3fab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224b3fab"]])

export default __exports__